<template>
  <el-card>
    <level-form @save="handleAddSubmit" />
  </el-card>
</template>

<script>
import LevelForm from "@/components/member-level/LevelForm";
import {request} from "@/config/request";
export default {
  name: "MemberLevelAdd",
  components: {LevelForm},
  data() {
    return {
    }
  },
  methods: {
    // 新增提交
    async handleAddSubmit(data) {
      try {
        await request(this.$api.vipLevel.add, data);
        this.$message.success("新增成功");
        this.$router.back();
      } catch (e) {
        console.log(e);
      }
    },
  },
  created() {
    this.loadDetail();
  }
}
</script>

<style scoped>
</style>
